import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import type { IAuditoriaAcaoItem } from "@/api/space/dtos/authenticator.dto";
import { AppBadge } from "@/components/ui/appBadge";
import { AUDITORIA_ACAO_LABELS } from "../auditoria.constants";
import { ICONE_ACAO, COLOR_ACAO } from "../auditoria.utils";

/** Badge da ação de um item de auditoria (inserido/ativado/desativado/inalterado). */
export default function BadgeAcao({ acao }: { readonly acao: IAuditoriaAcaoItem }) {
	return (
		<AppBadge color={COLOR_ACAO[acao]} icone={<FuseSvgIcon size={14}>{ICONE_ACAO[acao]}</FuseSvgIcon>}>
			{AUDITORIA_ACAO_LABELS[acao]}
		</AppBadge>
	);
}
